import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();
  
  const getBreadcrumbItems = () => {
    const path = location?.pathname;
    const items = [];

    // Sempre começar pelo Dashboard
    items?.push({ label: 'Painel', path: '/member-dashboard', isActive: false });

    switch (path) {
      case '/member-list':
        items?.push({ label: 'Membros', path: '/member-list', isActive: true });
        break;
      case '/member-registration':
        items?.push({ label: 'Membros', path: '/member-list', isActive: false });
        items?.push({ label: 'Cadastro', path: '/member-registration', isActive: true });
        break;
      case '/member-details':
        items?.push({ label: 'Membros', path: '/member-list', isActive: false });
        items?.push({ label: 'Detalhes do Membro', path: '/member-details', isActive: true });
        break;
      case '/member-import':
        items?.push({ label: 'Importar', path: '/member-import', isActive: true });
        break;
      case '/member-dashboard': case'/':
        items[0].isActive = true;
        break;
      default:
        items[0].isActive = true;
    }

    return items;
  };

  const breadcrumbItems = getBreadcrumbItems();

  // Don't show breadcrumbs on login page
  if (location?.pathname === '/login') {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      {breadcrumbItems?.map((item, index) => (
        <React.Fragment key={item?.path}>
          {index > 0 && (
            <Icon name="ChevronRight" size={16} className="text-border" />
          )}
          {item?.isActive ? (
            <span className="text-foreground font-medium" aria-current="page">
              {item?.label}
            </span>
          ) : (
            <Link
              to={item?.path}
              className="hover:text-foreground transition-colors duration-200 contextual-fade"
            >
              {item?.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;